export default __webpack_public_path__ + "static/media/destination-icon.7beb257e.svg";